import {i18n} from '@/plugins/i18n'
import {templateStatusStr, templateStatusVariant} from '@/constants/onlineContract'
import {contractTemplateTypeStr} from "@/constants/contractTemplateType";
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('online_contract.title'),
        sortable: false,
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        sortable: false,
        textAlign: 'center',
        template: (row) => '<span dir="ltr">' + row.created_at + '</span>',
        width: 90
    },
    {
        field: 'status',
        sortable: true,
        textAlign: 'center',
        title: i18n.t('label.status'),
        template: (row) => {
            let status = templateStatusStr.get(row.status)
            let variant = 'badge-' + templateStatusVariant(row.status)

            return '<div class="badge ' + variant + ' text-white">' + status + '</div>'
        },
        width: 80
    },
    {
        field: 'type',
        sortable: false,
        textAlign: 'center',
        title: i18n.t('online_contract.type'),
        template: (row) => {
            let type =contractTemplateTypeStr.get(row.type);
            return '<div>' + type + '</div>'
        },
        width: 80
    },
]